import { useState, useEffect } from "react";
import SimpleListbox from "../../../../components/input/SimpleListbox";
import { STUDENT_TRAIT_AND_TOTAL_SCORES } from "../../student/performance/PerformanceReport";
import { studentPerformanceLink } from "./PerformanceReport";
import {
	WriterEssayTraitScore,
	EssayTraitScore,
	WriterEssayTraitScoreKey,
	EssayTraitScoreKey,
} from "./ScoresFilteredByCourseViewModel";
import { TraitChartFilter, TraitScoreEChart } from "./TraitScoreChart";

export const essayTraits: TraitChartFilter[] = [
	{ value: "totalScore", label: "Total Score", maxValue: 30 },
	{ value: "developmentOfIdeasScore", label: "Development of Ideas", maxValue: 5 },
	{ value: "organizationScore", label: "Organization", maxValue: 5 },
	{ value: "styleScore", label: "Style", maxValue: 5 },
	{ value: "wordChoiceScore", label: "Word Choice", maxValue: 5 },
	{ value: "sentenceStructureScore", label: "Sentence Fluency", maxValue: 5 },
	{ value: "conventionsScore", label: "Conventions", maxValue: 5 },
	{ value: "textualEvidenceScore", label: "Textual Evidence", maxValue: 3 },
	{ value: "contentAccuracyScore", label: "Content Accuracy", maxValue: 3 },
];

export const essayOptions = essayTraits.map((t) => ({ value: t.value, label: t.label }));

export function EssayTraitScoreChart(props: {
	className?: string;
	courseId: number;
	writerData: WriterEssayTraitScore[];
	classData: EssayTraitScore;
}) {
	const getData = (filter: TraitChartFilter) => {
		const data = props.writerData.map((data) => {
			const value = data[filter.value as WriterEssayTraitScoreKey];
			return {
				name: data.writerName,
				value: value != null ? Number(value) : null,
				link: studentPerformanceLink(
					props.courseId,
					data.writerId,
					STUDENT_TRAIT_AND_TOTAL_SCORES
				),
			};
		});
		return data.find((d) => d.value !== null) ? data : [];
	};
	const getAverage = (filter: TraitChartFilter) => {
		return props.classData[filter.value as EssayTraitScoreKey];
	};

	const [selected, setSelected] = useState(essayTraits[0]);

	useEffect(() => {
		const trait = essayTraits.find((t) => t.value === selected.value) ?? essayTraits[0];
		setSelected(trait);
	}, [selected]);

	if (!props.writerData || props.writerData.length == 0) return "";

	return (
		<div className={props.className}>
			<SimpleListbox
				id="viewFilter"
				options={essayOptions}
				value={selected.value}
				className="w-1/5"
				onChange={(e) =>
					setSelected(
						essayTraits.find((t) => t.value === e.target.value) ?? essayTraits[0]
					)
				}
			/>

			<TraitScoreEChart
				data={getData(selected)}
				dataLabel={selected.label}
				average={getAverage(selected)}
				maxValue={selected.maxValue}
			/>
		</div>
	);
}
